import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0a868933"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "invite-box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "教学视频", -1));
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  key: 0,
  class: "aliPlayer"
};
const _hoisted_5 = {
  key: 0,
  class: "action-info"
};
const _hoisted_6 = ["onClick"];
import { env } from "md-base-tools/env";
import { onMounted, reactive } from "vue";
import { GoBack, mdToast } from "../../utils/tools";
import { useRoute } from "vue-router";
import { videoStyduSuccess } from "@/api";
import CompVideo from "../../components/task/focus_video.vue";
export default {
  setup(__props) {
    const route = useRoute();
    const state = reactive({
      if_video_play: false,
      if_video_end: false,
      if_request_success: false,
      video_cover: "",
      video_url: "",
      task_id: "",
      pro_id: ""
    });
    onMounted(() => {
      document.title = "教学视频";
      if (route.query.video_url && route.query.video_url.length > 0 && route.query.task_id && route.query.pro_id) {
        state.video_url = route.query.video_url;
        state.video_cover = route.query.video_url.replace(".mp4", ".png");
        state.task_id = route.query.task_id;
        state.pro_id = route.query.pro_id;
      }
    });
    function playVideo() {
      state.if_video_play = true;
    }

    //离开页面
    function handleGoBack() {
      GoBack();
    }

    //播放完成
    function videoEndEvent() {
      state.if_video_play = false;
      state.if_video_end = true;
      console.log("播放完成");

      // 播放结束-自动上报
      updateVideoGuideStatus(true);
    }

    // 上报视频学习进度
    async function updateVideoGuideStatus(is_auto = false) {
      // 如果上报成功-点击直接返回，不再重复请求
      if (state.if_request_success == true) {
        GoBack();
      } else {
        // 如果上报未成功-开始请求
        const {
          status,
          message
        } = await videoStyduSuccess({
          pro_id: state.pro_id,
          task_id: state.task_id
        });
        if (status == 0) {
          state.if_request_success = true;
          if (is_auto == false) {
            GoBack();
          }
        } else {
          mdToast(message);
        }
      }
    }
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("header", {
        class: _normalizeClass([{
          headerIOS: _unref(env).isModianIos()
        }, {
          headerAndroid: _unref(env).isModianAndroid()
        }, {
          isFix: _ctx.isFix
        }])
      }, [_createVNode(_component_van_image, {
        class: "back-btn",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/nav_back_white.png', 32),
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => handleGoBack(), ["stop"]))
      }, null, 8, ["src"]), _hoisted_2], 2), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "video",
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => playVideo(_unref(state).video_url), ["stop"]))
      }, [_unref(state).if_video_play ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(CompVideo, {
        class: "videoController",
        video_url: _unref(state).video_url,
        onVideoEndEvent: videoEndEvent
      }, null, 8, ["video_url"])])) : _createCommentVNode("", true), _createVNode(_component_van_image, {
        "lazy-load": "",
        class: "video-cover",
        src: _ctx.$imgUrlFilter(_unref(state).video_cover, 750)
      }, null, 8, ["src"]), _createElementVNode("div", {
        class: "play-btn",
        style: _normalizeStyle(`background-image:url(${_ctx.$imgUrlFilter('https://p6.moimg.net/md/icon/video_play@2x.png', 112, 112)});`)
      }, null, 4)])]), _unref(state).if_video_end ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", {
        class: "action-btn",
        onClick: _withModifiers(updateVideoGuideStatus, ["stop"])
      }, " 观看结束 ", 8, _hoisted_6)])) : _createCommentVNode("", true)]);
    };
  }
};